import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function ToolFaq({ items, toolSlug }) {
    const [open, setOpen] = useState(0);
    if (!items?.length) return null;
    return (
        <section
            className="bl-section bg-bl-surface border-y border-bl"
            data-testid="tool-faq"
        >
            <div className="bl-container max-w-3xl">
                <div className="bl-eyebrow">FAQ</div>
                <h2 className="mt-4 font-display font-semibold text-3xl tracking-tight text-bl">
                    Common questions
                </h2>
                <div className="mt-8 space-y-2">
                    {items.map((item, i) => {
                        const expanded = open === i;
                        return (
                            <div
                                key={i}
                                className="border border-bl rounded-xl bg-bl-bg overflow-hidden"
                                data-testid={`tool-faq-item-${i}`}
                            >
                                <button
                                    type="button"
                                    onClick={() => setOpen(expanded ? -1 : i)}
                                    className="w-full px-5 py-4 flex items-center justify-between gap-3 text-left"
                                    aria-expanded={expanded}
                                    data-testid={`tool-faq-toggle-${i}`}
                                >
                                    <span className="font-medium text-bl text-base">
                                        {item.q}
                                    </span>
                                    <ChevronDown
                                        className={`h-4 w-4 text-bl-muted transition-transform duration-200 shrink-0 ${expanded ? "rotate-180" : ""}`}
                                    />
                                </button>
                                {expanded && (
                                    <div className="px-5 pb-5 text-sm text-bl-muted leading-relaxed">
                                        {item.a}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
